<template>
  <div id="tab-user-order-list">
      <!-- <div class="block overflow-x-auto"> -->
        <div class="vx-row">
          <div class="vx-col lg:w-1/6 md:w-1/4 sm:w-1/3 w-full">
            <label class="text-sm opacity-75">{{$t('Start')}}</label>
            <datepicker :language="languages[language]" :placeholder="$t('SelectDate')" v-model="SearchParam.start"></datepicker>
          </div>
          <div class="vx-col lg:w-1/6 md:w-1/4 sm:w-1/3 w-full">
            <label class="text-sm opacity-75">{{$t('End')}}</label>
            <datepicker :language="languages[language]" :placeholder="$t('SelectDate')" v-model="SearchParam.end"></datepicker>
          </div>
          <div class="vx-col p-5 lg:w-1/6 md:w-1/4 sm:w-1/3 w-full">
            <vs-button color="success" type="filled" icon-pack="feather" icon="icon-search" @click="GetData">{{$t('Search')}}</vs-button>
          </div> 
        </div>
        <grid-view-handler 
        v-if="usersData.length > 0"
          :usersData="usersData" 
          :columnDefs="getColumnDefs" 
          :cookieName = "paramCookieName"
          :FloatingFilter="false"
          :searchQuery="SearchQuery"> 
      </grid-view-handler>
      <!-- </div> -->
  </div>
</template>

<script>

import GridViewHandler from '@/views/components/grid/GridViewHandler'
import Datepicker from 'vuejs-datepicker'
import * as lang from 'vuejs-datepicker/src/locale'

export default {
  components: {
    GridViewHandler,
    Datepicker
  },
  props: {
    // data: {
    //   type: Array,
    //   required: true
    // },
    login: {
      type: Number,
      required: true,
      default:0
    },
    serverType: {
      type: String,
      required: true,
      default:'Real'
    }
  },
  data () {
    return {
      language: 'tr',
      languages: lang,
      data_local: [], //JSON.parse(JSON.stringify(this.data)),
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [],
      paramCookieName: 'CustomerOrderList',
      SearchQuery: '',
      SearchParam:{
        end: null,
        start: null,
        client:'',
        server:''
      }
    }
  },

  methods: {
    GetData () {
      this.SearchParam.client = this.login
      this.SearchParam.server = this.serverType
      if (this.SearchParam.start === null) {
        return 0
      }
      if (this.SearchParam.start.toString().length > 11) {
        const s = this.SearchParam.start

        this.SearchParam.start = `${ s.getFullYear() }-${  (`0${s.getMonth() + 1}`).slice(-2)  }-${ (`0${  s.getDate()}`).slice(-2)  }`
      }
      if (this.SearchParam.end.toString().length > 11) {
        const e = this.SearchParam.end

        this.SearchParam.end = `${ e.getFullYear() }-${  (`0${e.getMonth() + 1}`).slice(-2)  }-${ (`0${  e.getDate()}`).slice(-2)  }`
      }

      this.$store.dispatch('Mt5Management/fetchClientHistory', this.SearchParam)
        .then(res => {
          const tmpData = JSON.parse(JSON.stringify(res.data.Data))
          tmpData.map(res => {
            res.OpenAction = res.OpenAction === 0 ? 'Buy' : 'Sell'

            res.Volume = res.Volume / 10000

            switch (res.Reason) {
            case 0:
              res.Reason = 'Client'
              break
            case 1:
              res.Reason = 'Expert'
              break
            case 2:
              res.Reason = 'Dealer'
              break
            case 3:
              res.Reason = 'Signal'
              break
            case 4:
              res.Reason = 'Gateway'
              break
            case 5:
              res.Reason = 'Mobile'
              break
            case 6:
              res.Reason = 'Web'
              break 
            case 7:
              res.Reason = 'API'
              break
            }
          })
          this.data_local = tmpData
          return this.data_local
          // console.error(res.data.Data)

        })
    },
    SetVolume () {

    }
  },
  computed: {
    getColumnDefs () {
      return [
        {
          headerName: this.$t('PositionID'),
          i18n:this.$t('PositionID'),
          field: 'PositionID',
          filter: true,
          width: 100,
          hide: false,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Login'),
          i18n:this.$t('Login'),
          field: 'Login',
          filter: true,
          width: 120,
          hide: false,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Symbol'),
          i18n:this.$t('Symbol'),
          field: 'Symbol',
          filter: true,
          width: 100,
          hide: false,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Digits'),
          i18n:this.$t('Digits'),
          field: 'Digits',
          filter: true,
          width: 80,
          hide: false,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('OpenAction'),
          i18n:this.$t('OpenAction'),
          field: 'OpenAction',
          filter: true,
          width: 100,
          hide: false,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Volume'),
          i18n:this.$t('Volume'),
          field: 'Volume',
          filter: true,
          width: 70,
          hide: false,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('OpenTime'),
          i18n:this.$t('OpenTime'),
          field: 'OpenTime',
          filter: true,
          width: 160,
          hide: false,
          valueFormatter: dateFormatter,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('PricePosition'),
          i18n:this.$t('PricePosition'),
          field: 'PricePosition',
          filter: true,
          width: 120,
          hide: false,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('PriceSL'),
          i18n:this.$t('PriceSL'),
          field: 'PriceSL',
          filter: true,
          width: 160,
          hide: false,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('PriceTP'),
          i18n:this.$t('PriceTP'),
          field: 'PriceTP',
          filter: true,
          width: 100,
          hide: false,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Time'),
          i18n:this.$t('Time'),
          field: 'Time',
          filter: true,
          width: 160,
          hide: false,
          valueFormatter : dateFormatter,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Reason'),
          i18n:this.$t('Reason'),
          field: 'Reason',
          filter: true,
          width: 100,
          hide: false,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Commission'),
          i18n:this.$t('Commission'),
          field: 'Commission',
          filter: true,
          width: 100,
          hide: false,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Price'),
          i18n:this.$t('Price'),
          field: 'Price',
          filter: true,
          width: 100,
          hide: false,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Profit'),
          i18n:this.$t('Profit'),
          field: 'Profit',
          filter: true,
          width: 100,
          hide: false,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Storage'),
          i18n:this.$t('Storage'),
          field: 'Storage',
          filter: true,
          width: 100,
          hide: false,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Deal'),
          i18n:this.$t('Deal'),
          field: 'Deal',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Timestamp'),
          i18n:this.$t('Timestamp'),
          field: 'Timestamp',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('ExternalID'),
          i18n:this.$t('ExternalID'),
          field: 'ExternalID',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
       
        {
          headerName: this.$t('Dealer'),
          i18n:this.$t('Dealer'),
          field: 'Dealer',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Order'),
          i18n:this.$t('Order'),
          field: 'Order',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Action'),
          i18n:this.$t('Action'),
          field: 'Action',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Entry'),
          i18n:this.$t('Entry'),
          field: 'Entry',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        
        {
          headerName: this.$t('DigitsCurrency'),
          i18n:this.$t('DigitsCurrency'),
          field: 'DigitsCurrency',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('ContractSize'),
          i18n:this.$t('ContractSize'),
          field: 'ContractSize',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('TimeMsc'),
          i18n:this.$t('TimeMsc'),
          field: 'TimeMsc',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('VolumeExt'),
          i18n:this.$t('VolumeExt'),
          field: 'VolumeExt',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('AgentCommission'),
          i18n:this.$t('AgentCommission'),
          field: 'AgentCommission',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Fee'),
          i18n:this.$t('Fee'),
          field: 'Fee',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('RateProfit'),
          i18n:this.$t('RateProfit'),
          field: 'RateProfit',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('RateMargin'),
          i18n:this.$t('RateMargin'),
          field: 'RateMargin',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Comment'),
          i18n:this.$t('Comment'),
          field: 'Comment',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('ProfitRaw'),
          i18n:this.$t('ProfitRaw'),
          field: 'ProfitRaw',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('VolumeClosedExt'),
          i18n:this.$t('VolumeClosedExt'),
          field: 'VolumeClosedExt',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('TickValue'),
          i18n:this.$t('TickValue'),
          field: 'TickValue',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('TickSize'),
          i18n:this.$t('TickSize'),
          field: 'TickSize',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Flags'),
          i18n:this.$t('Flags'),
          field: 'Flags',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Gateway'),
          i18n:this.$t('Gateway'),
          field: 'Gateway',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('PriceGateway'),
          i18n:this.$t('PriceGateway'),
          field: 'PriceGateway',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('ModifyFlags'),
          i18n:this.$t('ModifyFlags'),
          field: 'ModifyFlags',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Volume'),
          i18n:this.$t('Volume'),
          field: 'Volume',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('VolumeClosed'),
          i18n:this.$t('VolumeClosed'),
          field: 'VolumeClosed',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('ApiData'),
          i18n:this.$t('ApiData'),
          field: 'ApiData',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('OpenTimeMsc'),
          i18n:this.$t('OpenTimeMsc'),
          field: 'OpenTimeMsc',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('OpenReason'),
          i18n:this.$t('OpenReason'),
          field: 'OpenReason',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        },
        {
          headerName: this.$t('ExpertID'),
          i18n:this.$t('ExpertID'),
          field: 'ExpertID',
          filter: true,
          width: 100,
          hide: true,
          cellRendererFramework : 'genericCellRendererContent'
        }
      ]
    },
    validateForm () {
      return !this.errors.any()
    },
    usersData () {
      return this.data_local
      // return this.data_local.filter(f => f.)
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
  },
  created () {
    const d = new Date(Date.now())
    this.SearchParam.start = `${ d.getFullYear() }-${  (`0${d.getMonth() }`).slice(-2)  }-${ (`0${  d.getDate()}`).slice(-2)  }`
    this.SearchParam.end = `${ d.getFullYear() }-${  (`0${d.getMonth() + 1}`).slice(-2)  }-${ (`0${  d.getDate() + 1}`).slice(-2)  }`
    this.GetData()

  }
}
</script>
